import { Component } from '@angular/core';

@Component({
  selector: 'app-ad-empty',
  standalone: true,
  imports: [],
  templateUrl: './ad-empty.component.html',
  styleUrl: './ad-empty.component.scss'
})
export class AdEmptyComponent {

}
